const SESSION_KEY = "reppi_pin_unlock_session_v1";

export const PIN_UNLOCK_DURATIONS = [
  { value: 1, label: "1 minute" },
  { value: 5, label: "5 minutes" },
  { value: 15, label: "15 minutes" },
  { value: 30, label: "30 minutes" },
  { value: 60, label: "1 hour" },
];

export const DEFAULT_PIN_UNLOCK_DURATION = 5;

const canUseStorage = () =>
  typeof window !== "undefined" && typeof window.sessionStorage !== "undefined";

const readSession = () => {
  if (!canUseStorage()) return null;

  try {
    const raw = window.sessionStorage.getItem(SESSION_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!parsed?.expiresAt || Date.now() >= parsed.expiresAt) {
      clearPinUnlockSession();
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
};

export const startPinUnlockSession = ({ pin, durationMinutes }) => {
  if (!canUseStorage()) return;

  const safeDuration = Number(durationMinutes) || DEFAULT_PIN_UNLOCK_DURATION;
  const now = Date.now();
  const session = {
    verifiedAt: now,
    expiresAt: now + safeDuration * 60 * 1000,
    pin: String(pin || ""),
  };

  window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
};

export const clearPinUnlockSession = () => {
  if (!canUseStorage()) return;
  window.sessionStorage.removeItem(SESSION_KEY);
};

export const isPinUnlockSessionActive = () => Boolean(readSession());

export const getActivePin = () => {
  const session = readSession();
  return session?.pin || null;
};

export const getRemainingPinUnlockMs = () => {
  const session = readSession();
  if (!session) return 0;
  return Math.max(0, session.expiresAt - Date.now());
};
